import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setInterventionTypeIsEdit } from './redux/actions';
import Table from './Table';
import './index.less';

const InterventionTypes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [canUpdate, setCanUpdate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (user?.permissions?.intervention_types?.add_edit) {
      setCanUpdate(true);
    }
    if (user?.permissions?.intervention_types?.delete) {
      setCanDelete(true);
    }
  }, [user]);

  return (
    <div className='page-top-div'>
      <span className='text-span'>Intervention Types Manager</span>
      <Row className='production-manager-parent-row'>
        <Col span={24} className='heading-col'>
          <Row align='middle' gutter={[50, 0]}>
            <Col>
              <div>
                <span className='heading-span' style={{ color: '#0d2843' }}>
                  Intervention Types Register
                </span>
              </div>
            </Col>
            <Col>
              {canUpdate && (
                <Button
                  onClick={() => {
                    navigate('/settings/intervention-types-manager/create');
                    dispatch(setInterventionTypeIsEdit(true));
                  }}
                  icon={<PlusOutlined />}
                  className='add-user-btn'
                  size='middle'
                  style={{ width: 155, textTransform: 'uppercase' }}
                >
                  Intervention
                </Button>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table canUpdate={canUpdate} canDelete={canDelete} />
        </Col>
      </Row>
    </div>
  );
};

export default InterventionTypes;
